import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { Button } from "atoms/button/Button";

import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

type PersonalisationUserLoadErrorProps = {
  status?: number;
};

export const PersonalisationUserLoadError = ({ status }: PersonalisationUserLoadErrorProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isAuthError = status === 401 || status === 403;

  const title = isAuthError
    ? t("personalisationUserLoadError.authTitle")
    : t("personalisationUserLoadError.genericTitle");

  const body = isAuthError
    ? t("personalisationUserLoadError.authBody")
    : t("personalisationUserLoadError.genericBody");
  return (
    <PersonalisationScreenLayout
      disableAnimation
      contentClassName="flex flex-1 flex-col items-center justify-center text-center"
    >
      <div className="flex w-full max-w-[340px] flex-col gap-4">
        <div className="text-bold1">{title}</div>
        <div className="text-body1 text-secondary">{body}</div>
        <div className="flex flex-col gap-3 pt-2">
          <Button fullWidth onClick={() => navigate("/signin", { replace: true })}>
            {t("personalisationUserLoadError.goToSignIn")}
          </Button>
        </div>
      </div>
    </PersonalisationScreenLayout>
  );
};
